import formName from 'constants/formName'
import { actions } from 'data'
import { notifyError } from 'data/App/sagas'
import { TOtpConfigType, TwoFactorFormType } from 'data/types'
import { call, put } from 'redux-saga/effects'
import { create2FA } from 'services/api/user'
import { Response } from 'utils/fetchApi'

import { goToStep } from './common'

export default function* methodStep(form: TwoFactorFormType) {
  const data: Response<TOtpConfigType> = yield call(create2FA, {
    password: form.password,
    type: 'TOTP'
  })

  yield put(actions.form.change(formName.TWO_FACTOR, 'loading', false))

  if (!data.ok) {
    yield call(notifyError, data.error.cause, 'KO_GENERIC')
    return
  }

  yield put(actions.auth.setTotpConfig(data.response))

  yield call(goToStep, 'setup')
}
